import { Box, Icon, Separator, Tag, Text, useModalState } from '@bechtel/gds';
import { getSplittedToolCatalogName } from '@bechtel/ht-clients-common';
import { InventoryStatus, ToolCheckInItemsInput, ToolInventory } from '@bechtel/ht-types';
import { useContext, useMemo, useState } from 'react';
import { CommentDialog } from '~/components/molecules/comment-dialog';
import { EditCountField } from '~/components/molecules/edit-count-field';
import { ToolStatus } from '~/components/molecules/tool-status';
//@ts-ignore images ignore
import { ImageFallback } from '~/components/image-fallback';
import { ReturnToolContext } from '../../return-tool-context';
import { actionType } from '../../types';
import { ReturnDetailItemHoverStyled, ReturnDetailItemStyled } from './styled';
import { ReturnItemProps } from './types';

export const ReturnDetailItem: React.FC<ReturnItemProps> = ({ toolInventory, index }) => {
  const { updateData, selectedIds } = useContext(ReturnToolContext);
  const detail = useMemo(
    () => getSplittedToolCatalogName(toolInventory?.description ?? ''),
    [toolInventory?.description]
  );

  let status: InventoryStatus = InventoryStatus.GOOD;
  let quantity: number = 1;
  const isSerialised = toolInventory?.isSerialized;
  const { visible: commentDialogVisible, open: openCommentDialog, close: closeCommentDialog } = useModalState(false);
  const [focusedToolInventoryItem, setFocusedToolInventoryItem] = useState<ToolInventory | null>(null);
  let selectedRow: ToolCheckInItemsInput | undefined = undefined;
  if (selectedIds) {
    selectedRow = selectedIds.find((item: ToolCheckInItemsInput) => item.toolInventoryId == toolInventory.id);
    status = selectedRow && selectedRow.statusCode ? selectedRow.statusCode : InventoryStatus.GOOD;
    quantity = selectedRow ? selectedRow.quantity : 1;
  }
  const setSelectedStatus = (status: InventoryStatus) => {
    const tempToolInventory: ToolInventory = JSON.parse(JSON.stringify(toolInventory));
    updateData(actionType.UPDATE_STATUS, { checkInToolList: [tempToolInventory], statusCode: status });
  };

  const onToolCartItemCommentsUpdate = (comments) => {
    updateData(actionType.ADD_COMMENT, { checkInToolList: [toolInventory], comments: comments });
  };

  return (
    <ReturnDetailItemStyled>
      <ReturnDetailItemHoverStyled
        onMouseOver={(event) => {
          setFocusedToolInventoryItem(toolInventory);
          event.stopPropagation();
        }}
        onMouseLeave={() => {
          setFocusedToolInventoryItem(null);
          closeCommentDialog();
        }}
        px={{ sm: '500' }}
        pt={{ sm: '450' }}
        pb={{ sm: '550' }}
        justifyContent={{ sm: 'space-between' }}
      >
        <Box alignItems={{ sm: 'center' }}>
          <Box
            justifyContent={{ sm: 'center' }}
            alignItems={{ sm: 'center' }}
            my={{ sm: '200' }}
            ml={{ sm: '300' }}
            mr={{ sm: '500' }}
          >
            <ImageFallback
              src={toolInventory?.toolCatalog?.toolCatalogImageUrl}
              fallbackName={toolInventory?.toolCatalog?.toolCategory?.name}
            />
          </Box>
          <Box flexDirection={{ sm: 'column' }} style={{ flex: '1', width: 200 }}>
            <div>
              <Tag bgColor={isSerialised ? 'orange.200' : 'neutral.200'}>
                <Text size="250" family={'openSansCondensed'}>
                  {toolInventory?.barCode}
                </Text>
              </Tag>
            </div>
            <Box mt={{ sm: '200' }}>
              <Text color="grey.900" weight="600" size="450" family={'openSans'}>
                {detail.title}
              </Text>
            </Box>
            {detail.subTitle && (
              <Box mt={{ sm: '200' }} px={{ sm: '200' }}>
                <Text color="grey.600" weight="100" size="300" family={'openSans'}>
                  {detail.subTitle}{' '}
                  {toolInventory?.toolCatalog?.uom ? `(${toolInventory?.toolCatalog.uom.abbreviation})` : ''}
                </Text>
              </Box>
            )}
          </Box>
        </Box>
        <Box>
          <Box
            onClick={() => {
              openCommentDialog();
            }}
            style={{ cursor: 'pointer' }}
            alignItems={{ sm: 'center' }}
          >
            {selectedIds?.[index]?.comments && <Icon icon="comment-lines" iconStyle="solid" fillColor="primary.700" />}
            {!selectedIds?.[index]?.comments && (
              <Icon icon="comment-lines" iconStyle="regular" fillColor="primary.700" />
            )}
          </Box>
          <Box justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }} style={{ marginLeft: 8 }}>
            <Text color="grey.600" size="400" style={{ fontStyle: 'italic' }} family="openSansCondensed">
              {selectedIds?.[index]?.comments}
            </Text>
          </Box>
        </Box>
        <Box justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }} gap={{ sm: '300' }}>
          <EditCountField
            count={quantity}
            btnDisabled={isSerialised}
            onIncrement={() => {
              updateData(actionType.INCREMENT_QUANTITY, { checkInToolList: [toolInventory] });
            }}
            onDecrement={() => {
              if (quantity > 1) {
                updateData(actionType.Decrement_QUANTITY, { checkInToolList: [toolInventory] });
              } else if (quantity === 1) {
                updateData(actionType.REMOVE, { checkInToolList: [toolInventory] });
              }
            }}
          />

          {focusedToolInventoryItem?.id === toolInventory.id && (
            <CommentDialog
              onClose={closeCommentDialog}
              visible={commentDialogVisible}
              comment={selectedRow?.comments ?? ''}
              quantity={selectedRow?.quantity ?? 1}
              toolCatalog={toolInventory.toolCatalog}
              onCommentUpdated={onToolCartItemCommentsUpdate}
            />
          )}

          <ToolStatus
            disabled={!isSerialised ?? true}
            selectedStatus={status ?? InventoryStatus.GOOD}
            setSelectedStatus={setSelectedStatus}
          />
          <Box
            style={{ cursor: 'pointer' }}
            onClick={() => {
              updateData(actionType.REMOVE, { checkInToolList: [toolInventory] });
            }}
          >
            <Icon icon="minus-circle" />
          </Box>
        </Box>
      </ReturnDetailItemHoverStyled>
      <Separator spacing="000" color="grey.300" />
    </ReturnDetailItemStyled>
  );
};
